interface SupplierCirclesCarouselModel {
  suppliers: any[]
  isCarouselVisible: boolean
  getSuppliersCount: () => number
}

class SupplierCirclesCarousel {
  suppliers: any[]

  isCarouselVisible: boolean

  getSuppliersCount: () => number

  constructor(model: SupplierCirclesCarouselModel) {
    this.suppliers = model.suppliers || []
    this.isCarouselVisible = model.isCarouselVisible || false
    this.getSuppliersCount = model.getSuppliersCount || (() => 0)

    // Bind methods to the instance
    this.getCount = this.getCount.bind(this)
    this.isVisible = this.isVisible.bind(this)
    this.getSupplierByCode = this.getSupplierByCode.bind(this)
    this.getSupplierLabelByCode = this.getSupplierLabelByCode.bind(this)
  }

  /**
   * Returns the number of suppliers in the carousel
   */
  getCount(): number {
    return this.suppliers?.length || 0
  }

  /**
   * Checks if the carousel is visible
   */
  isVisible(): boolean {
    return this.isCarouselVisible
  }

  /**
   * Gets a supplier by code
   * @param code The supplier code to look for
   * @returns The supplier object or undefined if not found
   */
  getSupplierByCode(code: string): any | undefined {
    return this.suppliers?.find((supplier) => supplier['supplier.code'] === code)
  }

  /**
   * Gets the supplier label (name) by code
   * @param code The supplier code to look for
   * @returns The supplier label (name) or empty string if not found
   */
  getSupplierLabelByCode(code: string): string {
    const supplier = this.getSupplierByCode(code)
    return supplier?.['supplier.label'] || ''
  }
}

export default SupplierCirclesCarousel
